class InsuranceTacModal extends HTMLElement {
  constructor() {
    super();

    this.variantId = this.dataset.variantId;
    this.productId = this.dataset.productId;
    this.acceptButtonClick = false;
    this.warningText = this.dataset.warningText
      ? this.dataset.warningText
      : "You need to accept the terms and conditions before insurance can be added to your cart.";
    this.localizationData = {
      add: this.dataset.add,
      remove: this.dataset.remove,
    };

    this.initModalHandler();
    this.acceptButtonHandler();
    this.sessionModalHandler();
  }

  insuranceUpdateUnsubscriber = undefined;
  variantChangeUnsubscriber = undefined;

  connectedCallback() {
    this.insuranceUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.insuranceUpdate, this.insuranceUpdateHandler.bind(this));
    this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, () => {
      setTimeout(this.sessionModalHandler.bind(this));
    });
  }

  disconnectedCallback() {
    if (this.insuranceUpdateUnsubscriber) {
      this.insuranceUpdateUnsubscriber();
    }

    if (this.variantChangeUnsubscriber) {
      this.variantChangeUnsubscriber();
    }
  }

  sessionStorageHandler(id) {
    const sessionStorageData = sessionStorage.getItem("istyle-tac-id");
    const idsArray = sessionStorageData ? JSON.parse(sessionStorageData) : [];

    if (!idsArray.includes(id)) {
      idsArray.push(id);
      sessionStorage.setItem("istyle-tac-id", JSON.stringify(idsArray));

      setTimeout(this.sessionModalHandler.bind(this));
    }
  }

  sessionModalHandler() {
    const sessionStorageData = sessionStorage.getItem("istyle-tac-id");
    const idsArray = sessionStorageData ? JSON.parse(sessionStorageData) : [];

    if (idsArray.length) {
      if (this.dataset.template.includes("product") && idsArray.includes(this.dataset.termsId)) {
        const insuranceTACContainers = document.querySelectorAll(".pdp-insurance-btn-modal[data-id]");

        insuranceTACContainers.forEach((insuranceTACContainer) => {
          if (insuranceTACContainer.dataset.id === this.dataset.termsId) {
            const insuranceButton = insuranceTACContainer?.nextElementSibling;
            if (insuranceTACContainer && insuranceButton) {
              insuranceButton.classList.add("internal");

              if (this.dataset.template.startsWith("product") && this.dataset.template !== "product.pdp-2.0") {
                insuranceButton.classList.remove("hidden");
                insuranceTACContainer.remove();
              }
            }
          }
        });
      }

      if (this.dataset.template.includes("cart") && idsArray.length) {
        idsArray.forEach((storedId) => {
          const ctoDrawer = document.querySelector("cto-cart-drawer");
          const cartPage = document.querySelector("cart-items");
          const matchingElements = (ctoDrawer || cartPage).querySelectorAll(`[id*="${storedId}"]`);
          matchingElements.forEach((element) => {
            const idParts = element.id.split("-");
            if (idParts.includes(storedId)) {
              const insuranceButton = element.nextElementSibling;
              insuranceButton.classList.remove("insurance-hidden");
              element.remove();
            }
          });
        });
      }
    }
  }

  initModalHandler() {
    const selectAllCheckbox = this.querySelector(".select-all-checkbox");
    const checkboxes = this.querySelectorAll(".insurance-term-checkbox");

    selectAllCheckbox.addEventListener("change", () => {
      checkboxes.forEach((checkbox) => (checkbox.checked = selectAllCheckbox.checked));
      this.updateAcceptButtonState(checkboxes);
    });

    checkboxes.forEach((checkbox) => {
      checkbox.addEventListener("change", () => {
        selectAllCheckbox.checked = Array.from(checkboxes).every((checkbox) => checkbox.checked);
        this.updateAcceptButtonState(checkboxes);
      });
    });

    this.updateAcceptButtonState(checkboxes);
  }

  acceptButtonHandler() {
    const acceptButton = this.querySelector(".insurance-modal-button");
    const insuranceButtons = document.querySelectorAll(".insurance-button");
    const insuranceCTOButtons = document.querySelectorAll(".container-box-2");
    const insuranceContainer = document.querySelector(".insurance-replace");
    const isCTOCartDrawer = insuranceContainer?.dataset?.ctoCartDrawer;
    const template = this.dataset.template;

    acceptButton.addEventListener("click", () => {
      if (this.dataset.template.startsWith("product") && this.dataset.template !== "product.pdp-2.0") {
        insuranceButtons.forEach((insuranceButton) => {
          const insuranceModalButton = insuranceButton.previousElementSibling;
          const insuranceItemId = insuranceButton.dataset.index;
          const internalButton = insuranceButton.classList.contains("internal");
          !internalButton && insuranceButton.classList.toggle("hidden", insuranceItemId !== this.variantId);
          insuranceModalButton?.classList.toggle("hidden", insuranceItemId === this.variantId);
        });

        this.acceptInsuranceItem(this.variantId, isCTOCartDrawer);
      }

      if (this.dataset.template === "product.pdp-2.0" && insuranceCTOButtons) {
        insuranceCTOButtons.forEach((insuranceCTOButton) => {
          const insuranceItemId = insuranceCTOButton.dataset.index;
          const internalButton = insuranceCTOButton.classList.contains("internal");
          if (!internalButton) {
            insuranceCTOButton.querySelector("label").classList.toggle("checked", insuranceItemId === this.variantId);
          }

          this.acceptInsuranceCTOItem(this.variantId, insuranceCTOButtons);
        });
      }

      if (this.dataset.template.includes("cart")) {
        const addItemButton = document.querySelector(`[data-mainproductid="${this.productId}"][data-variantid="${this.variantId}"]`);

        if (addItemButton) {
          addItemButton.click();
          this.acceptButtonClick = true;
          document.querySelector(".modal-open button.modal-close-button")?.click();
        }
      }

      this.sessionStorageHandler(this.dataset.termsId);
    });
  }

  updateAcceptButtonState(checkboxes) {
    const allChecked = Array.from(checkboxes).every((checkbox) => checkbox.checked);
    const acceptBtn = this.querySelector(".insurance-modal-button");
    acceptBtn.toggleAttribute("disabled", !allChecked);
    acceptBtn.classList.toggle("disabled", !allChecked);
  }

  insuranceUpdateHandler(callback) {
    const { buttonId, status, modalId, type } = callback;
    const localModalId = this.dataset.modalId;
    if (!!buttonId) {
      if (type) {
        this.toggleCTOPanel(buttonId, status);
      } else {
        this.toggleInsuranceButton(buttonId, status);
      }
    }

    if (modalId === localModalId) {
      if (!this.acceptButtonClick && this.dataset.template.includes("cart")) {
        this.warningCartMessageHandler(modalId);
        return;
      }
      this.warningMessageHandler(document, this.acceptButtonClick);
      this.toggleCTOPanel(localModalId, this.acceptButtonClick);
      this.acceptButtonClick = false;
    }
  }

  warningMessageHandler(element, status) {
    const container = element.querySelector(".insurance-warning__message");
    const textBlock = container.querySelector(".insurance-warning__text");
    container.classList.toggle("hidden", status);
    textBlock.innerHTML = this.warningText;
  }

  warningCartMessageHandler(modalId) {
    const containers = document.querySelectorAll(".insurance-warning-cart");
    containers.forEach((container) => {
      const containerId = container.id;

      if (modalId.includes(containerId)) {
        container.classList.remove("hidden");
        this.warningMessageHandler(container, false);
      }
    });
  }

  modalOptionHandler() {
    document.querySelector(".modal-open button.modal-close-button")?.click();

    const checkboxes = this.querySelectorAll(".insurance-term-checkbox");
    const selectAllCheckbox = this.querySelector(".select-all-checkbox");

    if (selectAllCheckbox?.checked) {
      selectAllCheckbox.checked = false;
    }

    checkboxes.forEach((checkbox) => {
      if (checkbox.checked) {
        checkbox.checked = false;
      }
    });

    return checkboxes;
  }

  acceptInsuranceItem(itemId, cto = "") {
    const checkboxes = this.modalOptionHandler();
    this.updateAcceptButtonState(checkboxes);
    this.toggleInsuranceButton(itemId, true);
    this.acceptButtonClick = true;
    updateInsuranceItem(itemId, this.localizationData, "", cto);
  }

  acceptInsuranceCTOItem(itemId, buttons) {
    const checkboxes = this.modalOptionHandler();
    this.updateAcceptButtonState(checkboxes);
    this.acceptButtonClick = true;
    updateInsuranceCTOItem(itemId, buttons);
    coverageCTOItem(false);
  }

  toggleCTOPanel(id, status) {
    const insuranceContainer = document.querySelector(`.add-on-product-style-insurance[data-id="${id}"]`);
    const insuranceComponent = document.querySelector(`insurance-cto[data-modal-target="${id}"]`);
    const insuranceCTOContainer = insuranceContainer || insuranceComponent;
    const insuranceCTOButton = insuranceCTOContainer?.querySelector(".container-box-2");

    if (insuranceComponent && !status) {
      coverageCTOItem(true);
      coverageCTOHeading(insuranceCTOButton.dataset, false);
    }

    if (insuranceCTOButton) {
      insuranceCTOButton.querySelector(".add-on-insurance-checkbox").checked = status;
      insuranceCTOButton.querySelector("label").classList.toggle("checked", status);
    }
  }

  toggleInsuranceButton(id, status) {
    const insuranceContainer = document.querySelector(`[data-id="${id}"]`);
    const insuranceButton = insuranceContainer.querySelector(".insurance-button");
    const insuranceModalButton = insuranceButton.previousElementSibling;

    insuranceButton.classList.toggle("hidden", !status);
    insuranceModalButton.classList.toggle("hidden", status);
  }
}

customElements.define("insurance-tac-modal", InsuranceTacModal);
